import { Map, OrderedMap, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import ReviewTemplatesConstants from 'Shared/constants/ReviewTemplates.constants';
import FeedbacksConstants from 'Shared/constants/Feedbacks.constants';
import ReviewCyclesConstants from 'Shared/constants/ReviewCycles.constants';

const initialState = Map({
  [ReviewTemplatesConstants.State.REVIEWS_TEMPLATES_BY_SLUG]: OrderedMap(),
});

export const ReviewTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FeedbacksConstants.Actions.CREATE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_FEEDBACKS_SUCCESS:
    case ReviewTemplatesConstants.Actions.FETCH_REVIEW_TEMPLATES_SUCCESS:
    case ReviewTemplatesConstants.Actions.FETCH_REVIEW_TEMPLATE_SUCCESS:
    case ReviewTemplatesConstants.Actions.CREATE_REVIEW_TEMPLATE_SUCCESS:
    case ReviewTemplatesConstants.Actions.UPDATE_REVIEW_TEMPLATE_SUCCESS:
    case ReviewTemplatesConstants.Actions.DUPLICATE_REVIEW_TEMPLATE_SUCCESS:
    case ReviewCyclesConstants.Actions.FETCH_REVIEW_CYCLE_SUCCESS:
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn([ReviewTemplatesConstants.State.REVIEWS_TEMPLATES_BY_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          // @ts-ignore
          Object.values(action.payload.reviewTemplate).map(item => [item.attributes.slug, Map(fromJS(item.attributes))])
        )
      );

    case ReviewTemplatesConstants.Actions.DELETE_REVIEW_TEMPLATE_SUCCESS:
      return state.deleteIn([ReviewTemplatesConstants.State.REVIEWS_TEMPLATES_BY_SLUG, action.payload.slug]);

    default:
      return state;
  }
};
